<template>
  <li class="language-switcher">
    <span @click="$_changeLanguage()">{{ oppositeLanguage }}</span>
  </li>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'LanguageSwitcher',
  computed: {
    ...mapGetters([
      'lang'
    ]),
    oppositeLanguage: {
      get () {
        if ( this.lang === 'it' ) return 'en'
        return 'it'
      }
    }
  },
  methods: {
    ...mapMutations([
      'changeLanguage'
    ]),
    $_changeLanguage () {
      this.changeLanguage(this.oppositeLanguage)
      this.$router.push({ name: `${this.lang}.home` })
    }
  }
}
</script>

<style lang="scss">
  li.language-switcher span{
    text-transform: capitalize;
    cursor: pointer;
  }
</style>
